import React, { useEffect, useState } from "react";
import { IoIosAddCircleOutline } from "react-icons/io";
import AddTimeSheetPopup from "./AddTimeSheetPopup";
import ViewTimeSheetPopup from "./ViewTimeSheetPopup";
import axios from "axios";
import { base_url } from "../../../utils/AxiosConfig";
import { FallingLines } from "react-loader-spinner";
import { LuPanelLeftOpen } from "react-icons/lu";
import { LuPanelRightOpen } from "react-icons/lu";
import user1 from "../../../images/ic_no_person_photo.svg";
import Button from "@mui/joy/Button";

import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import { toast } from "react-toastify";
import { format } from "date-fns";
import { base_url_image_view_api } from "../../../utils/ImageViewingAPI";
import SnackbarNotification from "../../../utils/SnackbarNotification";

const TimeSheet = () => {
  const [countOfSuccessGeneration, setCountOfSuccessGeneration] = useState(0);

  const startOfMonth = new Date();
  startOfMonth.setUTCDate(1);

  let initialStartingDate = format(startOfMonth, "yyyy-MMM-dd");
  let initialEndingDate = format(new Date(), "yyyy-MMM-dd");

  const [timeSheetData, setTimeSheetData] = useState({
    startDate: initialStartingDate,
    endDate: initialEndingDate,
  });

  const [isLoading, setIsLoading] = useState(false);

  // Handle input change
  const handleChangeDate = (e) => {
    const { name, value } = e.target;
    setTimeSheetData({
      ...timeSheetData,
      [name]: value,
    });
  };

  const handleChange = (event, eventType) => {
    switch (eventType) {
      case "division":
        setDivisionMUI(event.target.value);
    }
  };

  const [selectedDivision, setSelectedDivision] = useState(null);
  const [selectedDivisionCode, setSelectedDivisionCode] = useState("-");

  const [divisionMUI, setDivisionMUI] = React.useState("");
  const storedUserDataArray = JSON.parse(
    localStorage.getItem("BondTimeuserDataArray"),
  );
  const storedLoginUser =
    JSON.parse(localStorage.getItem("BondTimeLoginUserData")) || [];
  let user = null;
  let companyCode = null;

  if (storedLoginUser) {
    // console.log('storedLoginUser[0]',storedLoginUser[0])
    // user = storedLoginUser[0].salesman_name.trim()
    user = storedLoginUser[0].user.trim();
  }

  if (storedUserDataArray) {
    companyCode = storedUserDataArray[0].cmpcode;
  }

  const [allBranchData, setAllBranchData] = useState([]);
  const [openViewModal, setOpenViewModal] = React.useState(false);

  const [data, setData] = useState();
  const [reset, setReset] = useState(false);
  const [loader, setLoader] = useState(true);
  const [popUpData, setpopUpData] = useState(null);
  const [Open, setOpen] = useState(false);

  // pagination
  const [currentPage, SetcurrentPage] = useState(1);
  const recordsPerPage = 10;
  const lastIndex = currentPage * recordsPerPage;
  const firstIndex = lastIndex - recordsPerPage;
  const records = data?.slice(firstIndex, lastIndex);
  const npage = Math.ceil(data?.length / recordsPerPage);
  const numbers = Array.from({ length: npage }, (_, i) => i + 1);

  const fetchProfilePic = (ImagePath) => {
    const filePath = ImagePath.replace(/\\/g, "/");
    const fileName = filePath.split("/").pop(); // Extracts the last part (filename with extension)

    // Construct the full URL for the image
    return `${base_url_image_view_api}/BONDTIME_EMP_IMG/${fileName}`;
  };

  useEffect(() => {
    const getData = async () => {
      try {
        const storedUserDataArray =
          JSON.parse(localStorage.getItem("BondTimeuserDataArray")) || [];
        let companyCode = null;

        if (storedUserDataArray) {
          companyCode = storedUserDataArray[0].cmpcode;
        }

        const response = await axios.get(
          `${base_url}/api/PersonalInfoList/${companyCode}/ALL/YES/ALL/ALL/ALL/ALL`,
        );
        if (response?.data) {
          setData(response.data);

          setReset(false);
        }
      } catch (error) {
        console.error("PersonalInfoListerror:", error);
      }
    };

    getData();
  }, []);

  useEffect(() => {
    if (data) {
      setLoader(false);
    }
  }, [data]);

  useEffect(() => {
    fetchAllBranchData();
  }, []);

  const fetchAllBranchData = async () => {
    try {
      const response = await axios.get(
        `${base_url}/api/MasterCount/${companyCode}/BRANCH/${user}/-`,
      );

      if (response.status === 200) {
        setAllBranchData(response.data);
        console.log("branch data", response.data);
      }
    } catch (error) {
      console.log("fetchAllBranchDataErr", error);
    }
  };

  const callGenerateTimeSheetAPI = async () => {
    for (let i = 0; i < records?.length; i++) {
      setIsLoading(true);

      try {
        const payload = [
          {
            mode: "ENTRY",
            cmpcode: companyCode,
            Empid: records[i]?.EmpId,
            StartDate: timeSheetData.startDate,
            EndDate: timeSheetData.endDate,
            deptno: selectedDivisionCode,
            jobcode: "-",
          },
        ];

        console.log("payload ", payload);

        const response = await axios.post(
          `${base_url}/api/TimesheetReg`,
          payload,
          {
            headers: {
              "Content-Type": "application/json",
            },
          },
        );

        if (response.status === 200) {
          setCountOfSuccessGeneration((prev) => prev + 1);

          // setTimeSheetData({
          //   startDate: "",
          //   endDate: ""
          // })
          showSnackbar("success", "Timesheet generated successfully");
        } else {
          //toast.error("Failed to submit timesheet.");
          showSnackbar("error", "Failed to generate timesheet.");
        }
      } catch (error) {
        //toast.error("An error occurred while submitting timesheet.");
      } finally {
        setIsLoading(false);
      }
    }
  };

  const [snackbar, setSnackbar] = useState({
    open: false,
    severity: "success",
    message: "",
  });

  const showSnackbar = (severity, message) => {
    setSnackbar({ open: true, severity, message });
  };

  const handleClose = () => {
    setSnackbar({ ...snackbar, open: false });
  };

   const formatDateWithExpiry = (date) => {
  if (!date) return <span>-</span>;

  const parsed = new Date(date);
  if (isNaN(parsed)) return <span>-</span>;

  const isExpired = parsed < new Date();

  return (
    <span className={isExpired ? "text-red-600 font-medium" : ""}>
      {parsed.toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "short",
        year: "numeric",
      })}
    </span>
  );
};

  return (
    <div className="container">
      <div className="mb-6 flex justify-between items-end">
        {/* <div className="col-6 d-flex align-items-center justify-content-between"> */}
        {/* <div className="">
          <h6 className=" text-2xl font-bold text-gray-600 flex  justify-start items-center">
            <span>Timesheet</span>
          </h6>
        </div> */}
        <div className="">
            <div className="flex justify-left items-center">
              <div className="w-1 h-8 bg-gradient-to-r from-[#2663EB] to-blue-400 rounded-full  mr-2"></div>
              <h6 className="text-xl font-bold text-gray-900 flex items-center gap-4">
                {/* <span className="inline-flex items-center justify-center w-12 h-12 rounded-xl bg-gradient-to-br from-[#2663EB] to-blue-700 text-white shadow-lg">
      <MdPersonAddAlt className="w-7 h-7" />
      </span> */}
                <span className="bg-gradient-to-r from-[#2663EB] to-blue-600 bg-clip-text text-transparent">
                  TIMESHEET
                </span>
              </h6>
              
            </div>
          </div>
<div className="">
        Number Of Successful Generation
        <span className="ms-2" style={{ fontWeight: "bold" }}>
          {countOfSuccessGeneration}
        </span>
      </div>
        {/* <div className='bg-green-500 flex '> */}
        <div className="flex justify-center items-end gap-4 ">
          <FormControl
            variant="standard"
            sx={{ m: 1, minWidth: 120, maxWidth: 180 }}
            size="small"
          >
            <InputLabel id="demo-simple-select-standard-label">
              Branch
            </InputLabel>
            <Select
              labelId="demo-simple-select-standard-label"
              id="demo-simple-select-standard"
              value={divisionMUI}
              onChange={(e) => handleChange(e, "division")}
              label="Branch"
            >
              <MenuItem value="">
                <em>None</em>
              </MenuItem>
              {allBranchData?.map((jobyy) => {
                return (
                  <MenuItem
                    onClick={(e) => {
                      setSelectedDivision(jobyy.deptnodesc);
                      setSelectedDivisionCode(jobyy.DEPTNO);
                    }}
                    value={jobyy.deptnodesc}
                  >
                    {jobyy.deptnodesc}
                  </MenuItem>
                );
              })}
            </Select>
          </FormControl>

          <div className="d-flex cursor-not-allowed">
            <div className="cursor-not-allowed">
              <label
                htmlFor="exampleInputEmail1"
                className="form-label fs-small text-secondary cursor-not-allowed"
              >
                Start Date
              </label>
              <input
                type="date"
                className="form-control cursor-not-allowed"
                id="startDate"
                name="startDate"
                value={timeSheetData.startDate}
                onChange={handleChange}
                max={new Date().toISOString().split("T")[0]}
              />
            </div>

            <div className="ms-2 cursor-not-allowed">
              <label
                htmlFor="exampleInputEmail1"
                className="form-label fs-small text-secondary cursor-not-allowed"
              >
                End Date
              </label>
              <input
                type="date"
                className="form-control cursor-not-allowed"
                id="endDate"
                name="endDate"
                value={timeSheetData.endDate}
                onChange={handleChange}
                max={new Date().toISOString().split("T")[0]}
              />
            </div>
          </div>

          <button
            onClick={() => callGenerateTimeSheetAPI()}
            className="btn btn-sm "
            style={{ backgroundColor: "#bc5090", color: "#ffffff" }}
          >
            Generate Timesheet All
          </button>
          {/* </div> */}
          <div className="">
            <div className="">
              {Open === true ? (
                <>
                  <LuPanelRightOpen onClick={() => setOpen(false)} />
                </>
              ) : null}
              {Open === false ? (
                <>
                  <LuPanelLeftOpen onClick={() => setOpen(true)} />
                </>
              ) : null}
            </div>
          </div>
        </div>
      </div>

      {/* <div className="mb-4">
        Number Of Successful Generation
        <span className="ms-2" style={{ fontWeight: "bold" }}>
          {countOfSuccessGeneration}
        </span>
      </div> */}

      {/* <div className={Open ? "table scroll" : "table scroll"}> */}
      <div className="overflow-auto max-h-30vh  rounded-md scrollbar-none">
        {records ? (
          <>
            {/* <table className="table"> */}
            <table className="shadow-sm min-w-full bg-white rounded-sm border border-gray-300 text-xs ">
              <thead>
                <tr className="bg-[#2663EB] text-white">
                  <th className="px-2 py-1  font-normal">Sl No</th>
                  <th className="px-2 py-1  font-normal">Emp Id</th>
                  <th className="px-2 py-1  font-normal">Alternate Id</th>
                  <th className="px-2 py-1  font-normal">Status</th>
                  <th className="px-2 py-1  font-normal">Name</th>
                  <th className="px-2 py-1  font-normal">Job Title</th>
                  <th className="px-2 py-1  font-normal">Division</th>
                  <th className="px-2 py-1  font-normal">Grade</th>
                  <th className="px-2 py-1  font-normal">Gender </th>
                  <th className="px-2 py-1  font-normal">Nationality</th>
                  {Open ? (
                    <>
                      <th className="px-2 py-1  font-normal">
                        Bank Account
                      </th>
                      <th className="px-2 py-1  font-normal">
                        Bank Name
                      </th>
                      <th className="px-2 py-1  font-normal">Agent Id</th>
                      <th className="px-2 py-1  font-normal">
                        Current Address
                      </th>
                      <th className="px-2 py-1  font-normal">
                        Home Address
                      </th>
                      <th className="px-2 py-1  font-normal">
                        Home Airport
                      </th>
                      <th className="px-2 py-1  font-normal">
                        Work Mobile
                      </th>
                      <th className="px-2 py-1  font-normal">
                        Work Phone
                      </th>
                      <th className="px-2 py-1  font-normal">
                        Personal Phone
                      </th>
                      <th className="px-2 py-1  font-normal">
                        Personal Email
                      </th>
                      <th className="px-2 py-1  font-normal">
                        Passport Number
                      </th>
                      <th className="px-2 py-1  font-normal">
                        Passport Issue Date
                      </th>
                      <th className="px-2 py-1  font-normal">
                        Passport Expiry Date
                      </th>
                      <th className="px-2 py-1  font-normal">
                        Passport Place of Issue
                      </th>
                      <th className="px-2 py-1  font-normal">
                        Passport Country of Issue
                      </th>
                      <th className="px-2 py-1  font-normal">
                        Emirates id
                      </th>
                      <th className="px-2 py-1  font-normal">
                        Expiry Date
                      </th>
                      <th className="px-2 py-1  font-normal">Visa No</th>
                      <th className="px-2 py-1  font-normal">
                        Visa Expiry Date
                      </th>
                      <th className="px-2 py-1  font-normal">
                        Insurance Number
                      </th>
                      <th className="px-2 py-1  font-normal">
                        Insurance Expiry Date
                      </th>
                      <th className="px-2 py-1  font-normal">
                        Driving license No
                      </th>
                      <th className="px-2 py-1  font-normal">
                        Driving license Expiry Date
                      </th>
                      <th className="px-2 py-1  font-normal">
                        Basic Pay
                      </th>
                      <th className="px-2 py-1  font-normal">
                        Allowances_OT
                      </th>
                      <th className="px-2 py-1  font-normal">
                        Allownaces_NOT
                      </th>
                      <th className="px-2 py-1  font-normal">
                        NormalHRS
                      </th>
                      <th className="px-2 py-1  font-normal">
                        HourlyWage
                      </th>
                      <th className="px-2 py-1  font-normal">OTRate</th>
                      <th className="px-2 py-1  font-normal">
                        SplOtRate
                      </th>
                      <th className="px-2 py-1  font-normal">Active</th>
                      <th className="px-2 py-1  font-normal">Memos</th>
                      <th className="px-2 py-1  font-normal">Notes</th>
                      <th className="px-2 py-1  font-normal">
                        Salary Ac
                      </th>
                      <th className="px-2 py-1  font-normal">
                        Advance Ac
                      </th>
                    </>
                  ) : null}
                  <th className="px-2 py-1  font-normal text-center">Actions</th>
                </tr>
              </thead>
              <tbody>
                {records
                  ? records?.map((d, i) => (
                      <>
                        <tr key={i} className="dataTr">
                          <td className="px-2 py-1 border">{i + 1}</td>
                          <td className="px-2 py-1 border">{d?.EmpId}</td>
                          <td className="px-2 py-1 border">{d?.AlternateID}</td>
                          <td className="px-2 py-1 border">{d?.Status}</td>
                          <td className="px-2 py-1 border">
                            <div
                              style={{ display: "flex", alignItems: "center" }}
                            >
                              {d.imagepath ? (
                                <img
                                  style={{
                                    width: "25px",
                                    height: "25px",
                                    borderRadius: "50%",
                                    objectFit: "cover",
                                    marginRight: "4px",
                                  }}
                                  src={fetchProfilePic(d.imagepath)}
                                  alt=""
                                />
                              ) : (
                                <img
                                  style={{
                                    width: "25px",
                                    height: "25px",
                                    borderRadius: "50%",
                                    objectFit: "cover",
                                    marginRight: "4px",
                                  }}
                                  src={user1}
                                  alt=""
                                />
                              )}
                              <span>{d?.Name}</span>
                            </div>
                          </td>
                          <td className="px-2 py-1 border">{d?.JobTitle}</td>
                          <td className="px-2 py-1 border">{d?.Division}</td>
                          <td className="px-2 py-1 border">{d?.Grade}</td>
                          <td className="px-2 py-1 border">{d?.Single}</td>
                          <td className="px-2 py-1 border">{d?.Nationality}</td>
                          {Open ? (
                            <>
                              <td className="px-2 py-1 border">
                                {d?.BankAccountNo}
                              </td>
                              <td className="px-2 py-1 border">
                                {d?.BankName}
                              </td>
                              <td className="px-2 py-1 border">{d?.AgentID}</td>
                              <td className="px-2 py-1 border">
                                {d?.CurrentAddress}
                              </td>
                              <td className="px-2 py-1 border">
                                {d?.HomeAddress}
                              </td>
                              <td className="px-2 py-1 border">
                                {d?.HomeAirport}
                              </td>
                              <td className="px-2 py-1 border">
                                {d?.WorkMobile}
                              </td>
                              <td className="px-2 py-1 border">
                                {d?.WorkPhone}
                              </td>
                              <td className="px-2 py-1 border">
                                {d?.PersonalPhone}
                              </td>
                              <td className="px-2 py-1 border">
                                {d?.PersonalEmail}
                              </td>
                              <td className="px-2 py-1 border">
                                {d?.PassportNo}
                              </td>
                              <td className="px-2 py-1 border">
                                {formatDateWithExpiry(d?.PassportIssueDate)}
                              </td>
                              <td className="px-2 py-1 border">
                                {formatDateWithExpiry(d?.PassportExpiryDate)}

                              </td>
                              <td className="px-2 py-1 border">
                                {d?.PassportPlaceofIssue}
                              </td>
                              <td className="px-2 py-1 border">
                                {d?.PassportCountryofIssue}
                              </td>
                              <td className="px-2 py-1 border">
                                {d?.EmiratesId}
                              </td>
                              <td className="px-2 py-1 border">
                                {formatDateWithExpiry(d?.EmiratesIdExpiryDate)}

                              </td>
                              <td className="px-2 py-1 border">{d?.VisaNo}</td>
                              <td className="px-2 py-1 border">
                                {formatDateWithExpiry(d?.VisaExpiryDate)}

                              </td>
                              <td className="px-2 py-1 border">
                                {d?.InsuranceNo}
                              </td>
                              <td className="px-2 py-1 border">
                                {formatDateWithExpiry(d?.InsuranceExpiryDate)}

                              </td>
                              <td className="px-2 py-1 border">
                                {d?.DrivingLicenceNo}
                              </td>
                              <td className="px-2 py-1 border">
                                {formatDateWithExpiry(d?.DrivingLicenceExpiryDate)}

                              </td>
                              <td className="px-2 py-1 border">
                                {d?.BasicPay}
                              </td>
                              <td className="px-2 py-1 border">
                                {d?.Allowances_OT}
                              </td>
                              <td className="px-2 py-1 border">
                                {d?.Allowances_NOT}
                              </td>
                              <td className="px-2 py-1 border">
                                {d?.NormalHrs}
                              </td>
                              <td className="px-2 py-1 border">
                                {d?.HourlyWage}
                              </td>
                              <td className="px-2 py-1 border">{d?.OTrate}</td>
                              <td className="px-2 py-1 border">
                                {d?.SplOtRate}
                              </td>
                              <td className="px-2 py-1 border">{d?.Active}</td>
                              <td className="px-2 py-1 border">{d?.Memos}</td>
                              <td className="px-2 py-1 border">{d?.Notes}</td>
                              <td className="px-2 py-1 border">{d?.SalaryA}</td>
                              <td className="px-2 py-1 border">
                                {d?.AdvanceAc}
                              </td>
                            </>
                          ) : null}
                          <td className="px-2 py-1 border flex justify-center items-center gap-2">
                            <button
                              // className="dash-btn"
                              className="bg-green-500 px-2 py-1 border rounded-lg text-white font-semibold"
                              data-bs-toggle="modal"
                              data-bs-target="#staticBackdrop"
                              onClick={() => setpopUpData(d)}
                            >
                              {/* <IoIosAddCircleOutline /> */}
                              {/* &nbsp; */}
                              Generate
                            </button>
                            &nbsp;
                            <button
                              // className="dash-btn mt-1"
                              className="bg-yellow-500 px-2 py-1 border rounded-lg text-white font-semibold"
                              onClick={() => {
                                setpopUpData(d);
                                setOpenViewModal(true);
                              }}
                            >
                              {/* <IoIosAddCircleOutline /> */}
                              {/* &nbsp; */}
                              View
                            </button>
                          </td>
                        </tr>
                      </>
                    ))
                  : null}
              </tbody>
            </table>
          </>
        ) : null}
      </div>
      {records ? (
        <>
          <div className="pagination-div">
            <div className="text-end">
              <nav aria-label="Page navigation example">
                <ul className="pagination mt-4">
                  <li className="page-item">
                    {currentPage !== 1 ? (
                      <button
                        className="page-link rounded"
                        href="#"
                        onClick={prePage}
                      >
                        Previous
                      </button>
                    ) : (
                      ""
                    )}
                  </li>
                  {numbers.map((n, i) => (
                    <li
                      className={`page-item ${
                        currentPage === n ? "active" : ""
                      }`}
                      key={i}
                    >
                      <button
                        className="page-link rounded"
                        onClick={() => changeCPage(n)}
                        href="#"
                      >
                        {n}
                      </button>
                    </li>
                  ))}

                  <li className="page-item">
                    {currentPage !== numbers[numbers.length - 1] ? (
                      <button
                        className="page-link rounded"
                        href="#"
                        onClick={nextPage}
                      >
                        Next
                      </button>
                    ) : null}
                  </li>
                </ul>
              </nav>
            </div>
            <SnackbarNotification
              open={snackbar.open}
              severity={snackbar.severity}
              message={snackbar.message}
              onClose={handleClose}
            />
          </div>
        </>
      ) : null}
      <AddTimeSheetPopup popUpData={popUpData} />
      {popUpData && (
        <ViewTimeSheetPopup
          popUpData={popUpData}
          setOpenViewModal={setOpenViewModal}
          openViewModal={openViewModal}
          setpopUpData={setpopUpData}
        />
      )}

      <div className="table-nodata-img mtd">
        {loader ? (
          <>
            {" "}
            <div className="table-nodata-img">
              <div className="center">
                <p className="text-center pt-5">
                  Please Wait Loading Data... &nbsp;
                  <FallingLines />
                </p>
              </div>
            </div>
          </>
        ) : null}
      </div>
    </div>
  );
  function prePage() {
    if (currentPage !== firstIndex) {
      SetcurrentPage(currentPage - 1);
    }
  }
  function changeCPage(id) {
    SetcurrentPage(id);
  }

  function nextPage() {
    if (currentPage !== lastIndex) {
      SetcurrentPage(currentPage + 1);
    }
  }
};

export default TimeSheet;
